import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=4aaed5bf&"
import script from "./SideNavigation.vue?vue&type=script&lang=js&"
export * from "./SideNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports